import { Component, Inject, OnInit, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { SaleTeamMappingEmployeeInfo } from '../model/SaleTeamMappingEmployeeInfo.model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { GlobalService } from '../service/global.service';
import { ActivatedRoute } from '@angular/router';
import { TokenService } from '../service/token.service';
import { environment } from 'src/environments/environment';
import { SaleTargetInfo } from '../model/SaleTargetInfo.model';
import { SaleTeamInfo } from '../model/SaleTeamInfo.model';
import { ProjectSaleInfo } from '../model/projectsale.model';
import { ServiceDeliveryBacklogDetailInfo } from '../model/ServiceDeliveryBacklogDetailInfo.model';
import { ReportSaleSummaryBacklogReturn } from '../model/ReportSaleSummaryBacklogReturn.model';
import { ReportSaleSummarySaleTargetReturn } from '../model/ReportSaleSummarySaleTargetReturn.model';

interface RowData {
  teamCode: string;
  teamName: string;
  empCode: string;
  empName: string;
  budget: number;
  newValue: number;
  backlog: number;
  overUnder: number;
}

interface GroupedTeam {
  teamName: string;
  budgetSum: number;  
  newValueSum: number;
  overUnderSum: number;
  backlogSum: number;
  employees: RowData[];
}


@Component({
  selector: 'app-sale-summary-report',
  templateUrl: './sale-summary-report.component.html',
  styleUrls: ['./sale-summary-report.component.css']
})
export class SaleSummaryReportComponent implements OnInit {
  _ForK2: string;
  _EmpCode: string;
  _ParamEmpCode: string;

  baseurl: string;

  yearOptions: ProjectSaleInfo[] = [];

  yearSearch: string = null;
  ddlMonthStart: string = null;
  ddlMonthEnd: string = null;

  isMonthEndValid: boolean = true;
  yearErrorMessage: string = '';
  monthErrorMessage: string = '';

  MonthList = [
    { MonthCode: '1', MonthName: 'Jan' },
    { MonthCode: '2', MonthName: 'Feb' },
    { MonthCode: '3', MonthName: 'Mar' },
    { MonthCode: '4', MonthName: 'Apr' },
    { MonthCode: '5', MonthName: 'May' },
    { MonthCode: '6', MonthName: 'Jun' },
    { MonthCode: '7', MonthName: 'Jul' },
    { MonthCode: '8', MonthName: 'Aug' },
    { MonthCode: '9', MonthName: 'Sep' },
    { MonthCode: '10', MonthName: 'Oct' },
    { MonthCode: '11', MonthName: 'Nov' },
    { MonthCode: '12', MonthName: 'Dec' },
  ];

  SaleTargetReturnList: ReportSaleSummarySaleTargetReturn[] = [];
  BacklogDetailNewList: ReportSaleSummaryBacklogReturn[] = [];
  BacklogDetailBacklogList: ReportSaleSummaryBacklogReturn[] = [];
  rowDataList: RowData[] = [];
  SaleTeamMapList: SaleTeamMappingEmployeeInfo[] = [];

  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string, private formBuilder: FormBuilder, private GlobalService: GlobalService, private activatedRoute: ActivatedRoute, private TokenService: TokenService) { 
    this.baseurl = environment.base_api;

    this._ForK2 = this.activatedRoute.snapshot.params.ForK2;
    this._ParamEmpCode = this.activatedRoute.snapshot.params.EmpCode;
   }

  async ngOnInit(): Promise<void> {
    this._EmpCode = !!this._ParamEmpCode ? this._ParamEmpCode : localStorage.getItem("EmpCode");
    if (!!this._ForK2) {
      localStorage.setItem("EmpCode", this._ParamEmpCode);
    }

    await this.initializeComponent();
    //await this.LoadSaleTeamMapList();
    //await this.LoadSaleTargetReturnList();
    //await this.LoadBacklogDetailNewList();
    //await this.LoadBacklogDetailBacklogList();

    await Promise.all([
    this.LoadSaleTeamMapList(),
    this.LoadSaleTargetReturnList(),
    this.LoadBacklogDetailNewList(),
    this.LoadBacklogDetailBacklogList()
  ]);

  console.log('--- All API calls finished ---')
    this.buildRowDataList();
  }

  async initializeComponent() {
    await this.loadInitialData();
  }

  async loadInitialData() {
    await this.loadLeadYears();
    //await this.LoadSaleTarget(true);
  }

  async loadLeadYears() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      try {
        const result = await this.httpClient.get<ProjectSaleInfo[]>(this.baseurl + "ProjectSale/GetLeadYears", httpOptions).toPromise();
        if (result && result.length > 0) {
          this.yearOptions = result;
          // Set the default year to the most recent year
          if (this.yearOptions.length >= 2) {
          this.yearSearch = result[result.length - 2].ProjectSaleYear;
          } else {
            this.yearSearch = result[result.length - 1].ProjectSaleYear;
          }
          console.log('Default year set to:', this.yearSearch);
        } else {
          console.error('No years returned from GetLeadYears');
          // Set current year as fallback
          const currentYear = new Date().getFullYear();
          this.yearSearch = currentYear.toString();
        }
      } catch (error) {
        console.error('Error loading years:', error);
        // Set current year as fallback
        const currentYear = new Date().getFullYear();
        this.yearSearch = currentYear.toString();
      }
    }
  }

  async LoadSaleTarget(isNewSearch: boolean = false) {
    if (isNewSearch) {
      // logic new search
    }

    //console.log('this.yearSearch', this.yearSearch);

    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };


      // Prepare search parameters
      var objectjson = {};
      
      objectjson['SaleTargetYear'] = this.yearSearch;
      //objectjson['SaleTargetFlagNewCust'] = 'N'; // Only get target values

      this.httpClient.post<SaleTargetInfo[]>(this.baseurl + "SaleTarget/GetSaleTargetActuals", objectjson, httpOptions)
        .subscribe(result => {
          console.log('API Response:', result);
          //this.SaleTargetList = result;
          //this.processData();
        }, error => console.error('API Error:', error));
      
      }
    
  }

  onddlMonthStartChange(event: Event): void {
  const selectElement = event.target as HTMLSelectElement;
  this.ddlMonthStart = selectElement.value || null;

    if (this.ddlMonthStart === null || this.ddlMonthStart === 'null') {
    this.ddlMonthEnd = null;
  }

  this.validateMonthRange();
}

  onddlMonthEndChange(event: Event): void {
   const selectElement = event.target as HTMLSelectElement;
   this.ddlMonthEnd = selectElement.value || null;

   if (this.ddlMonthEnd === null || this.ddlMonthEnd === 'null') {
    this.ddlMonthStart = null;
  }

   this.validateMonthRange();
  }

  validateMonthRange(): void {
    this.monthErrorMessage = '';

    this.isMonthEndValid = true;
  }

  async btnSearch_OnClick() {
    this.isMonthEndValid = true;
    this.monthErrorMessage = '';

  if (!this.yearSearch) {
    this.isMonthEndValid = false;
    this.monthErrorMessage = 'กรุณาเลือกปี';
    return;
  }

  // Helper function check null (include string "null")
  const isEmpty = (value: any) => {
    return value === null || 
           value === undefined || 
           value === '' || 
           value === 'null' ||  // Add this
           value === '0';
    };

    const isMonthStartEmpty = isEmpty(this.ddlMonthStart);
    const isMonthEndEmpty = isEmpty(this.ddlMonthEnd);

    // must select both or not select both
    if (isMonthStartEmpty !== isMonthEndEmpty) {
        this.isMonthEndValid = false;
        this.monthErrorMessage = 'กรุณาเลือก Month From และ Month To ให้ครบ';
        return;
    }

    // select both and check interval
    if (!isMonthStartEmpty && !isMonthEndEmpty) {
        const start = parseInt(this.ddlMonthStart.toString(), 10);
        const end = parseInt(this.ddlMonthEnd.toString(), 10);

        if (isNaN(start) || isNaN(end)) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'ค่าเดือนไม่ถูกต้อง';
            return;
        }

        if (end < start) {
            this.isMonthEndValid = false;
            this.monthErrorMessage = 'Month To ต้องมากกว่าหรือเท่ากับ Month From';
            return;
      }
  }

    //console.log('Year:', this.yearSearch);
    //console.log('Month From Pass:', this.ddlMonthStart);
    //console.log('Month To Pass:', this.ddlMonthEnd);
    //console.log('ผ่านการตรวจสอบ');
    await this.LoadSaleTeamMapList();
    await this.LoadSaleTargetReturnList();
    await this.LoadBacklogDetailNewList();
    await this.LoadBacklogDetailBacklogList();

    this.buildRowDataList();
  }

  async btnclear_OnClick() {
    this.yearSearch = null;
    this.ddlMonthStart = null;
    this.ddlMonthEnd = null;

    this.isMonthEndValid = true;
    await this.loadLeadYears();

    await this.LoadSaleTeamMapList();
    await this.LoadSaleTargetReturnList();
    await this.LoadBacklogDetailNewList();
    await this.LoadBacklogDetailBacklogList();

    this.buildRowDataList();
  }

  async LoadSaleTargetReturnList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare search parameters
      var objectjson = {};
      
      objectjson['SaleTargetYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['monthEnd'] = this.ddlMonthEnd;

      console.log('objectjson', objectjson);

      try {
        const result = await this.httpClient.post<ReportSaleSummarySaleTargetReturn[]>(this.baseurl + "ProjectSaleReport/GetSaleTargetForProjectSaleSummaryReport", objectjson,
        httpOptions).toPromise();

        this.SaleTargetReturnList = result;
        console.log('SaleTargetReturnList', this.SaleTargetReturnList);
        // this.processData();
      } catch (error) {
        console.error('API Error:', error);
      }
      
    }
  }

  async LoadBacklogDetailNewList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare search parameters
      var objectjson = {};
      
      objectjson['BacklogDetailYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['monthEnd'] = this.ddlMonthEnd;

      console.log('objectjson', objectjson);

      try {
        const result = await this.httpClient.post<ReportSaleSummaryBacklogReturn[]>(this.baseurl + "ProjectSaleReport/GetBacklogDetailNewForProejctSaleSummaryReport", objectjson,
        httpOptions).toPromise();

        this.BacklogDetailNewList = result;
        console.log('BacklogDetailNewList', this.BacklogDetailNewList);
        // this.processData();
      } catch (error) {
        console.error('API Error:', error);
      }
      
    }
  }

  async LoadBacklogDetailBacklogList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare search parameters
      var objectjson = {};
      
      objectjson['BacklogDetailYear'] = this.yearSearch;
      objectjson['MonthStart'] = this.ddlMonthStart;
      objectjson['monthEnd'] = this.ddlMonthEnd;

      console.log('objectjson', objectjson);

      try {
        const result = await this.httpClient.post<ReportSaleSummaryBacklogReturn[]>(this.baseurl + "ProjectSaleReport/GetBacklogDetailBacklogForProejctSaleSummaryReport", objectjson,
        httpOptions).toPromise();

        this.BacklogDetailBacklogList = result;
        console.log('BacklogDetailNewList', this.BacklogDetailBacklogList);
        // this.processData();
      } catch (error) {
        console.error('API Error:', error);
      }
      
    }
  }

  groupedData0(): GroupedTeam[] {
    const empMap = new Map<string, RowData>();

    // 1. Old budget From SaleTargetReturnList
    this.SaleTargetReturnList.forEach(item => {
    const key = item.SaleTargetTeamCode + '_' + item.SaleTargetEmpCode;
      empMap.set(key, {
        teamCode: item.SaleTargetTeamCode,
        teamName: item.SaleTargetTeamName,
        empCode: item.SaleTargetEmpCode,
        empName: item.SaleTargetEmpName,
        budget: item.SaleTargetAmount || 0,
        newValue: 0,
        backlog: 0,
        overUnder: 0
      });
    });

    // 2. Fill newValue from BacklogDetailNewList
    this.BacklogDetailNewList.forEach(item => {
      const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
      const row = empMap.get(key);
        if (row) {
          row.newValue = Number(item.TotalPrice) || 0;
        } else {
          empMap.set(key, {
          teamCode: item.ProjectSaleTeamCode,
          teamName: item.TeamName,
          empCode: item.EmpCode,
          empName: item.EmpName,
          budget: 0,
          newValue: Number(item.TotalPrice) || 0,
          backlog: 0,
          overUnder: 0
        });
      }
    });

    // 3. Fill backlog From BacklogDetailBacklogList
    this.BacklogDetailBacklogList.forEach(item => {
      const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
      const row = empMap.get(key);
        if (row) {
          row.backlog = Number(item.TotalPrice) || 0;
        } else {
          empMap.set(key, {
          teamCode: item.ProjectSaleTeamCode,
          teamName: item.TeamName,
          empCode: item.EmpCode,
          empName: item.EmpName,
          budget: 0,
          newValue: 0,
          backlog: Number(item.TotalPrice) || 0,
          overUnder: 0
        });
      }
    });

    // 4. Calculate overUnder = newValue - budget
    empMap.forEach(row => {
      row.overUnder = row.newValue - row.budget;
    });

    // 5. Conclude by Team with calculate sum
    const teamMap = new Map<string, GroupedTeam>();

      empMap.forEach(row => {
        if (!teamMap.has(row.teamCode)) {
          teamMap.set(row.teamCode, {
          teamName: row.teamName,
          budgetSum: 0,
          newValueSum: 0,
          overUnderSum: 0,
          backlogSum: 0,
          employees: []
        });
      }

    const team = teamMap.get(row.teamCode)!;
      team.employees.push(row);
      team.budgetSum += row.budget;
      team.newValueSum += row.newValue;
      team.overUnderSum += row.overUnder;
      team.backlogSum += row.backlog;
    });

    return Array.from(teamMap.values());
  }

  groupedData(): GroupedTeam[] {
    // ตรวจสอบว่า rowDataList มีข้อมูลหรือไม่
    if (!this.rowDataList || this.rowDataList.length === 0) {
      return [];
    }

    // สร้าง Map สำหรับจัดกลุ่มข้อมูลตาม TeamCode
    const teamMap = new Map<string, GroupedTeam>();

    this.rowDataList.forEach(row => {
    if (!teamMap.has(row.teamCode)) {
      teamMap.set(row.teamCode, {
        teamName: row.teamName,
        budgetSum: 0,
        newValueSum: 0,
        overUnderSum: 0,
        backlogSum: 0,
        employees: []
      });
    }

    const team = teamMap.get(row.teamCode)!;
    team.employees.push(row);
    team.budgetSum += row.budget;
    team.newValueSum += row.newValue;
    team.overUnderSum += row.overUnder;
    team.backlogSum += row.backlog;
  });

    // ส่งคืน Array ของข้อมูลที่ถูกจัดกลุ่มแล้ว
    return Array.from(teamMap.values());
  }

  buildRowDataList0(): void {
    const empMap = new Map<string, RowData>();

    // 1. Fill budget From SaleTargetReturnList
    this.SaleTargetReturnList.forEach(item => {
      const key = item.SaleTargetTeamCode + '_' + item.SaleTargetEmpCode;
      empMap.set(key, {
        teamCode: item.SaleTargetTeamCode,
        teamName: item.SaleTargetTeamName,
        empCode: item.SaleTargetEmpCode,
        empName: item.SaleTargetEmpName,
        budget: item.SaleTargetAmount || 0,
        newValue: 0,
        backlog: 0,
        overUnder: 0
      });
    });

    // 2. Fill newValue From BacklogDetailNewList
    this.BacklogDetailNewList.forEach(item => {
    const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
    const row = empMap.get(key);
      if (row) {
        row.newValue = Number(item.TotalPrice) || 0;
      } else {
      empMap.set(key, {
        teamCode: item.ProjectSaleTeamCode,
        teamName: item.TeamName,
        empCode: item.EmpCode,
        empName: item.EmpName,
        budget: 0,
        newValue: Number(item.TotalPrice) || 0,
        backlog: 0,
        overUnder: 0
      });
    }
  });

  // 3. Fill backlog From BacklogDetailBacklogList
  this.BacklogDetailBacklogList.forEach(item => {
    const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
    const row = empMap.get(key);
    if (row) {
      row.backlog = Number(item.TotalPrice) || 0;
    } else {
      empMap.set(key, {
        teamCode: item.ProjectSaleTeamCode,
        teamName: item.TeamName,
        empCode: item.EmpCode,
        empName: item.EmpName,
        budget: 0,
        newValue: 0,
        backlog: Number(item.TotalPrice) || 0,
        overUnder: 0
      });
    }
  });

  // 4. Calculate overUnder = newValue - budget
  empMap.forEach(row => {
    row.overUnder = row.newValue - row.budget;
  });

    // 5. Create array from map store in rowDataList
    this.rowDataList = Array.from(empMap.values());
  }

  buildRowDataList(): void {
    const empMap = new Map<string, RowData>();

    // 1. สร้างโครงสร้างข้อมูลหลักจาก SaleTeamMapList เป็นแกนหลัก
    this.SaleTeamMapList.forEach(item => {
    const key = item.SaleTeamCode + '_' + item.EmployeeCode;
    empMap.set(key, {
      teamCode: item.SaleTeamCode,
      teamName: item.SaleTeamName,
      empCode: item.EmployeeCode,
      empName: item.EmployeeName || '', 
      budget: 0,
      newValue: 0,
      backlog: 0,
      overUnder: 0
    });
  });

  // 2. เติมข้อมูล budget จาก SaleTargetReturnList (เฉพาะพนักงานที่มีอยู่ใน empMap)
  this.SaleTargetReturnList.forEach(item => {
    const key = item.SaleTargetTeamCode + '_' + item.SaleTargetEmpCode;
    const row = empMap.get(key);
    if (row) {
      row.budget = item.SaleTargetAmount || 0;
    }
  });

  // 3. เติมข้อมูล newValue จาก BacklogDetailNewList (เฉพาะพนักงานที่มีอยู่ใน empMap)
  this.BacklogDetailNewList.forEach(item => {
    const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
    const row = empMap.get(key);
    if (row) {
      row.newValue = Number(item.TotalPrice) || 0;
    }
  });

  // 4. เติมข้อมูล backlog จาก BacklogDetailBacklogList (เฉพาะพนักงานที่มีอยู่ใน empMap)
  this.BacklogDetailBacklogList.forEach(item => {
    const key = item.ProjectSaleTeamCode + '_' + item.EmpCode;
    const row = empMap.get(key);
    if (row) {
      row.backlog = Number(item.TotalPrice) || 0;
    }
  });

  // 5. คำนวณ overUnder สำหรับทุก row ที่มี
  empMap.forEach(row => {
    row.overUnder = row.newValue - row.budget;
  });

  // 6. สร้าง array จาก map และเก็บใน rowDataList
  this.rowDataList = Array.from(empMap.values());
}

  getTotal(column: keyof RowData): number {
    return this.rowDataList.reduce((sum, row) => {
      const val = Number(row[column]) || 0;
      return sum + val;
    }, 0);
  }

  formatOverUnder(value: number): string {
  if (value === null || value === undefined || value === 0) {
    return '0';
  }

  const isNegative = value < 0;
  const absoluteValue = Math.abs(value);
  
  let result = '';
  
  if (absoluteValue >= 1000000) {
    const millionValue = absoluteValue / 1000000;
    let formattedValue = millionValue.toFixed(2);
    formattedValue = formattedValue.replace(/\.?0+$/, '');
    result = formattedValue + 'M';
  } else {
    result = absoluteValue.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }
  
  // เพิ่มวงเล็บสำหรับตัวเลขติดลบ
  return isNegative ? `(${result})` : result;
}

  formatNumber(value: number): string {
    if (value == null || isNaN(value)) {
      return '-';
    }
    return value.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  }

  getTotalBudget(): number {
    return this.groupedData().reduce((total, team) => 
      total + team.employees.reduce((teamTotal, emp) => teamTotal + emp.budget, 0), 0);
  }

  getTotalNew(): number {
    return this.groupedData().reduce((total, team) => 
      total + team.employees.reduce((teamTotal, emp) => teamTotal + emp.newValue, 0), 0);
  }

  getTotalOverUnder(): number {
    return this.groupedData().reduce((total, team) => 
      total + team.employees.reduce((teamTotal, emp) => teamTotal + emp.overUnder, 0), 0);
  }

  getTotalBacklog(): number {
    return this.groupedData().reduce((total, team) => 
      total + team.employees.reduce((teamTotal, emp) => teamTotal + emp.backlog, 0), 0);
  }

  formatNumberWithMillion(value: number): string {
  if (value === null || value === undefined || value === 0) {
    return '0';
  }

  const absoluteValue = Math.abs(value);
  
  // ตรวจสอบว่าเกินหรือเท่ากับ 7 หลัก (1,000,000 ขึ้นไป)
  if (absoluteValue >= 1000000) {
    const millionValue = value / 1000000;
    
    // แสดง 2 ทศนิยม แล้วตัดเลข 0 ท้าย
    let formattedValue = millionValue.toFixed(2);
    
    // ตัดเลข 0 ท้ายออก
    formattedValue = formattedValue.replace(/\.?0+$/, '');
    
    return formattedValue + 'M';
  } else {
    // ถ้าไม่ถึง 7 หลัก ใช้รูปแบบเดิม (มี comma)
    return value.toLocaleString('en-US', {
      minimumFractionDigits: 0,
      maximumFractionDigits: 2
    });
  }
}

  async LoadSaleTeamMapList() {
    var auth_token = await this.TokenService.RefreshToken();
    if (!!auth_token) {
      const httpOptions = {
        headers: new HttpHeaders({
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${auth_token}`
        })
      };

      // Prepare search parameters
      var objectjson = {};
      
      objectjson['EmployeeCode'] = this._EmpCode;

      //console.log('objectjson', objectjson);

      try {
        const result = await this.httpClient.post<SaleTeamMappingEmployeeInfo[]>(this.baseurl + "Team/GetEmployeeMappingTeamAllEmp", objectjson,
        httpOptions).toPromise();

        this.SaleTeamMapList = result;
        console.log('SaleTeamMapList', this.SaleTeamMapList);
        // this.processData();
      } catch (error) {
        console.error('API Error:', error);
      }
      
    }
  }

}
